import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'redirect-to-button',
  template: `
    <button class="btn-link" (click)="redirect()">
      {{ label }}
    </button>
  `,
  styleUrls: ['./feature-notification.component.scss'], // Opcional, si quieres estilos separados
})
export class RedirectToButtonComponent {
  @Input() label: string;
  @Input() redirectTo: string;

  constructor(private router: Router) {}

  /**
   * Navigates to the route specified by the 'redirectTo' property if it is set.
   *
   * @date 30/06/2025
   * @author Ricardo Condori
   */
  redirect(): void {
    if (this.redirectTo) {
      this.router.navigate([this.redirectTo]);
    }
  }
}
